module.exports = __webpack_public_path__ + "static/media/index.bf8f6cf5.mjs";